import { Badge } from '@/components/ui/badge'
import { formatNumber, getResourceBadgeVariant } from '@/utils/number'

interface ResourceDisplayProps {
  limit: number | null
  used: number
  remaining: number | null
}

export const ResourceDisplay: React.FC<ResourceDisplayProps> = ({
  limit,
  used,
  remaining,
}) => {
  if (limit === null) {
    return (
      <div className='flex items-center gap-2'>
        <span className='text-sm text-muted-foreground'>Unlimited</span>
        <Badge variant='outline' className='text-xs'>
          {used} used
        </Badge>
      </div>
    )
  }

  const isLow = remaining !== null && remaining <= limit * 0.2
  const isCritical = remaining !== null && remaining <= limit * 0.1
  const badgeVariant = getResourceBadgeVariant(isCritical, isLow)

  return (
    <div className='space-y-1'>
      <div className='flex items-center justify-between gap-2'>
        <div className='flex items-center gap-2'>
          <span className='text-sm font-medium'>
            {formatNumber(used)} / {formatNumber(limit)}
          </span>
          {remaining !== null && (
            <Badge variant={badgeVariant} className='text-xs'>
              {formatNumber(remaining)} left
            </Badge>
          )}
        </div>
      </div>
    </div>
  )
}
